export const validateTextField = (fieldName: string, maxLength: number, required: boolean) => {
    return (_: any, value: string) => {

        const text = value ? value.replace(/<[^>]*>/g, "").trim() : "";

        // Check required only if required is true
        if (required && !text) {
            return Promise.reject(new Error(`${fieldName} is required.`));
        }

        // If optional and empty, skip other validations
        if (!text) {
            return Promise.resolve();
        }

        if (text.length > maxLength) {
            return Promise.reject(
                new Error(`${fieldName} cannot exceed ${maxLength} characters.`)
            );
        }

        // Only numbers or decimals are not allowed
        if (/^[0-9.]+$/.test(text.trim())) {
            return Promise.reject(
                new Error(`${fieldName} cannot contain only numbers or decimals!`)
            );
        }

        return Promise.resolve();
    };
};